import { ModalShell } from './ModalShell';

type Props = {
  open: boolean;
  onCancel: () => void;
  onConfirm: () => void;
};

const RED = '#ff4a4a';

export function ExitConfirmModal({ open, onCancel, onConfirm }: Props) {
  return (
    <ModalShell
      open={open}
      onClose={onCancel}
      accent={RED}
      title="ВЫЙТИ ИЗ ИГРЫ?"
      subtitle="ПРОГРЕСС ВЫЛАЗКИ БУДЕТ ПОТЕРЯН"
      icon={
        // 8-ray burst — reads as "abrupt exit" rather than a generic close X.
        <svg width="26" height="26" viewBox="0 0 26 26" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round">
          <circle cx="13" cy="13" r="3" fill="currentColor" stroke="none"/>
          <path d="M13 2 v4 M13 20 v4 M2 13 h4 M20 13 h4"/>
          <path d="M5 5 l3 3 M18 18 l3 3 M5 21 l3-3 M18 8 l3-3"/>
        </svg>
      }
      footer={
        <>
          <button
            type="button"
            onClick={onCancel}
            style={{
              flex: 1, appearance: 'none', border: 0, cursor: 'pointer', borderRadius: 8,
              padding: '10px 0', fontFamily: 'var(--f-display)', fontSize: 12, letterSpacing: '0.1em',
              background: 'rgba(255,255,255,0.08)', color: 'var(--tx-dim)',
            }}
          >ОТМЕНА</button>
          <button
            type="button"
            onClick={onConfirm}
            style={{
              flex: 1, appearance: 'none', border: 0, cursor: 'pointer', borderRadius: 8,
              padding: '10px 0', fontFamily: 'var(--f-display)', fontSize: 12, letterSpacing: '0.1em',
              background: RED, color: '#fff',
            }}
          >✕ ВЫХОД</button>
        </>
      }
    >
      <div style={{ color: 'var(--tx-dim)', fontSize: 12.5, lineHeight: 1.45 }}>
        Закрыть мини-приложение? Рыбки и расходники сохраняются между сессиями, но текущая вылазка сбросится.
      </div>
    </ModalShell>
  );
}
